import { composeIO } from 'react-compose-io'
import { fieldsBuscarLinhaIO } from './FieldsBuscarLinha.IO'
import FieldsBuscarLinhaView from './FieldsBuscarLinha.View'

export const FieldsBuscarLinha = composeIO(FieldsBuscarLinhaView, fieldsBuscarLinhaIO)
